import { __rest } from "tslib";
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { context } from './utils';
import SimpleControl from './simple.control';
const Control = (_a) => {
    var { onToggle } = _a, props = __rest(_a, ["onToggle"]);
    const { opened, toggle, registerControl, dataTest: contextDataTest } = useContext(context);
    const control = useRef(null);
    useEffect(() => {
        registerControl(control.current);
    }, [registerControl]);
    const handleToggle = useCallback((_opened, event) => {
        toggle();
        if (onToggle) {
            onToggle(!opened, event);
        }
    }, [opened, onToggle, toggle]);
    return (React.createElement(SimpleControl, Object.assign({}, props, { dataTest: contextDataTest ? `${contextDataTest}-control` : props.dataTest, refControl: control, onToggle: handleToggle, opened: opened })));
};
export default Control;
//# sourceMappingURL=control.js.map